export const iconFontAwesomeAnimalsHippo = (
	<i className="fa-solid fa-hippo"></i>
);
